import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  rootCheckbox: {
    color: '#65ac1e'
  },
  labelCheck: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
    fontSize: '14px',
    color: 'rgba(39, 58, 57, 0.8)',
  },
}));